import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { updateEmail } from 'redux/entities/actions'
import { isUpdatingEmail, updateEmailError } from 'redux/entities/selectors'
import { useHasLoadingSucceeded } from 'hooks'

export function useEmailValidation({ accountId, onValidation, oldEmail, newEmail }) {
  const dispatch = useDispatch()

  const isValidating = useSelector((state) => isUpdatingEmail(state, accountId))
  const validateError = useSelector((state) => updateEmailError(state, accountId))
  const hasAccountBeenValidated = useHasLoadingSucceeded(isValidating, validateError)

  useEffect(() => {
    if (hasAccountBeenValidated) onValidation()
  }, [hasAccountBeenValidated, onValidation])

  function validateAccount() {
    dispatch(updateEmail(accountId, { old_email: oldEmail, new_email: newEmail }))
  }

  return { isValidating, validateError, validateAccount }
}
